import { render } from "./ZPreview.vue?vue&type=template&id=daba8908&ts=true"
import script from "./ZPreview.vue?vue&type=script&lang=ts"
export * from "./ZPreview.vue?vue&type=script&lang=ts"

import "./ZPreview.vue?vue&type=style&index=0&id=daba8908&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__